import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import App from './App';
const rootElement = document.querySelector('.js-sudoku');
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(_jsx(App, {}));
}
